import { NoticeProps, components } from "react-select";
import type { TClueSelectDefaultOption } from "../../ClueSelect.types";
import "./NoOptionsMessage.styles.scss";

type NoOptionsMessageProps<
  Option extends TClueSelectDefaultOption = TClueSelectDefaultOption
> = {
  noOptionsText: string;
} & NoticeProps<Option, false>;

export const NoOptionsMessage = <
  Option extends TClueSelectDefaultOption = TClueSelectDefaultOption
>(
  props: NoOptionsMessageProps<Option>
): JSX.Element => {
  const { noOptionsText } = props;

  return (
    <components.NoOptionsMessage
      {...props}
      className="nb-interactive-clue-select-no-options"
    >
      {noOptionsText ? noOptionsText : props.children}
    </components.NoOptionsMessage>
  );
};
